import { ReactElement } from 'react';
import { Tooltip as MuiTooltip, tooltipClasses } from '@mui/material';
import { makeStyles } from '@mui/styles';

import Typography from '@classify/react-core-components/Typography';

export interface Props {
  children: ReactElement;
  title?: string;
  content?: string;
  placement?: 'right-start' | 'right-end';
}

const useStyles = makeStyles(({ spacing, palette, shadows }) => ({
  container: {
    padding: spacing(2),
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    color: palette.brand.primary,
  },
  tooltipContainer: {
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: palette.background.primary,
      color: palette.text.onMain,
      boxShadow: shadows[1],
    },
    [`& .${tooltipClasses.arrow}`]: {
      color: palette.background.primary,
    },
  },
}));

const Tooltip = ({ children, title, content, placement = 'right-start' }: Props) => {
  const classes = useStyles();
  const shouldShowTooltip = Boolean(title) || Boolean(content);

  return (
    <MuiTooltip
      data-testid="tooltipDrawerMenuItem"
      classes={{
        popper: classes.tooltipContainer,
      }}
      title={
        shouldShowTooltip ? (
          <>
            <div className={classes.container}>
              {title && (
                <Typography className={classes.title} variant="subheadingSmall">
                  {title}
                </Typography>
              )}
              {content && (
                <Typography
                  variant="caption"
                  dangerouslySetInnerHTML={{ __html: content }}
                  sx={{
                    ...(title && { paddingTop: 1 }),
                  }}
                />
              )}
            </div>
          </>
        ) : (
          ''
        )
      }
      placement={placement}
      arrow
      role="tooltip"
    >
      <span>{children}</span>
    </MuiTooltip>
  );
};

export default Tooltip;
